import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { handleWebPageOpenEvent } from "../../utils/utils";
import { RouteName } from "../../utils/route.utils";
import { useSelector } from "react-redux";
import { termsData } from "../../utils/constants/CompanyPage";
import Footer from "../../components/common/Footer";
import Head from "next/head";
import TAGS from "../../public/headJson.json";
import Container from "../../components/common/Container";

export default function TermsAndConditions(props) {
  const { webviewEvent } = props;
  const router = useRouter();
  const firebase_uid = useSelector((state) => state?.currentUser?.firebaseUID);

  useEffect(() => {
    handleWebPageOpenEvent({
      type: "terms_and_condition_page",
      webviewEvent,
      firebase_uid,
    });
  }, [firebase_uid]);

  return (
    <main className="App">
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.termsAndCondition.title}</title>
        <meta name="title" content={TAGS.termsAndCondition.title} />
        <meta name="description" content={TAGS.termsAndCondition.description} />
        <link rel="canonical" href={RouteName.termsAndCondition} />

        {/* Facebook / Open Graph */}
        <meta property="og:url" content={RouteName.termsAndCondition} />
        <meta property="og:title" content={TAGS.termsAndCondition.title} />
        <meta property="og:image" content={TAGS.landingPage.imageUrl} />
        <meta property="og:image:alt" content="Seekho" />
        <meta
          property="og:description"
          content={TAGS.termsAndCondition.description}
        />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.termsAndCondition} />
        <meta property="twitter:title" content={TAGS.termsAndCondition.title} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@seekhoapp" />
        <meta property="twitter:image" content={TAGS.landingPage.imageUrl} />
        <meta
          property="twitter:description"
          content={TAGS.termsAndCondition.description}
        />
      </Head>

      <section className="bg-black text-white font-lexend">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#AF30BF] via-[#5E30BF] to-[#065959] py-12 px-6 md:px-16 lg:px-32 text-center shadow-lg">
          <h1 className="font-lexend text-3xl md:text-5xl font-bold lg:text-4xl">
            Terms and Conditions
          </h1>
          <p className="font-lexend mt-2 text-base text-gray-200">
            Last updated: October, 19 2026
          </p>
          <p className="font-lexend mt-6 max-w-3xl mx-auto text-gray-100 leading-relaxed">
            Please read these terms and conditions carefully before using Our
            Service.
          </p>
        </div>

        {/* Content with TOC */}
        <Container className="mx-auto md:px-12 py-12 lg:grid lg:grid-cols-4 gap-10">
          {/* Sidebar TOC */}
          <aside className="hidden lg:block col-span-1 sticky top-24 space-y-5">
            {termsData.map((s, i) => (
              <a
                key={i}
                href={`?#section-${i}`}
                className="font-lexend block text-[16px] text-gray-400 hover:text-purple-400 transition cursor-pointer"
              >
                {s.title}
              </a>
            ))}
          </aside>

          {/* Main Content */}
          <main className="col-span-3 space-y-8 text-justify">
            {termsData.map((section, idx) => (
              <section
                id={`section-${idx}`}
                key={idx}
                className="bg-gray-900/70 rounded-xl p-4 md:p-8 shadow-md hover:shadow-purple-600/20 transition scroll-mt-24"
              >
                <h6 className="font-lexend text-xl font-semibold text-purple-400 mb-3 lg:text-2xl">
                  {section.title}
                </h6>

                <h6
                  className="font-lexend text-gray-300"
                  dangerouslySetInnerHTML={{ __html: section?.subTitle }}
                />

                <ul
                  className={`${
                    section?.content?.length > 1 ? "list-disc pl-6" : ""
                  } space-y-2 text-gray-300 leading-relaxed mt-3`}
                >
                  {section?.content?.map((point, i) => (
                    <li
                      key={i}
                      dangerouslySetInnerHTML={{ __html: point }}
                      className="font-lexend"
                    />
                  ))}
                </ul>

                <h6
                  className="font-lexend text-gray-300 mt-3"
                  dangerouslySetInnerHTML={{ __html: section.bottomText }}
                />
              </section>
            ))}
          </main>
        </Container>
      </section>

      {router.query?.source !== "android" && (
        <div className="mt-32 lg:mt-20">
          <Footer />
        </div>
      )}
    </main>
  );
}
